<template>
    <nav class="gh-breadcrumb" aria-label="Breadcrumb">
        <div class="gh-breadcrumb__outer">
            <div class="gh-breadcrumb__inner">
                <div class="gh-breadcrumb__content">
                    <a class="gh-breadcrumb__link" href="/">首頁</a>
                    <span
                        v-for="(node, index) in normalizedNodeList"
                        :key="`node-${index}`"
                        class="gh-breadcrumb__node"
                    >
                        <span class="gh-breadcrumb__separator">></span>
                        <a
                            v-if="!isLastNode(index)"
                            class="gh-breadcrumb__link"
                            :href="node.url"
                        >
                            {{ node.name }}
                        </a>
                        <span v-else class="gh-breadcrumb__current">
                            {{ node.name }}
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </nav>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { BreadcrumbNodeItem } from '@/types/components/base-components.types';

    // ----- props -----
    const props = withDefaults(
        defineProps<{
            nodeList?: BreadcrumbNodeItem[];
        }>(),
        {
            nodeList: () => [],
        }
    );

    // ----- computed -----
    const normalizedNodeList = computed(() => props.nodeList);

    // ----- methods -----
    const isLastNode = (index: number): boolean => {
        return index === normalizedNodeList.value.length - 1;
    };
</script>

<style lang="scss" scoped>
    .gh-breadcrumb {
        display: flex;

        @media (max-width: 770px) {
            padding-inline: 12px;
        }
    }

    .gh-breadcrumb__outer {
        width: $contentOuter;
        margin: 0 auto;
        transition: width 0.3s ease-out;

        // >= 1400px
        @include rwdL($fullHD) {
            width: $contentOuterHD;
        }

        // <= 1399px
        @include rwd($fullHD - 1) {
            width: 1000px;
        }

        // <= 1200px
        @include rwd($contentOuterHD) {
            width: 80%;
        }

        // <= 1000px
        @include rwd($pc + 10) {
            width: 90%;
        }

        // <= 770px
        @include rwd($pad) {
            width: 100%;
        }
    }

    .gh-breadcrumb__inner {
        position: relative;
        width: 100%;
        float: left;
    }

    .gh-breadcrumb__content {
        margin: 11px 0;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 4px;
        color: $textColor888;
        letter-spacing: 1px;
    }

    .gh-breadcrumb__node {
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }

    .gh-breadcrumb__link {
        color: $textColor888;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    .gh-breadcrumb__current {
        color: $textColor45;
        font-weight: 700;
    }
</style>
